// export const environment = {
//   production: true,
//   firebase: {
//     apiKey: '********************************',
//     authDomain: '********************************',
//     projectId: '********************************',
//     storageBucket: '********************************',
//     messagingSenderId: '********************************',
//     appId: '********************************',
//     measurementId: '********************************',
//   },
// };

export const environment = {
  production: true,

  //////////////////////////////////////Develop////////////////////////////////////////////////  
  // apiUrl: 'http://mob.gigatel.me:60202/api/',
  // iciciApiUrl: ' https://mob.gigatel.me:40905/api/',
  // iciciRedirectPortalUrl: ' https://pgpayuat.icicibank.com/tsp/pg/api/v2/authRedirect?tranCtx=',
  //////////////////////////////////////Develop////////////////////////////////////////////////  
  
  
  //////////////////////////////////////Production////////////////////////////////////////////////  
  apiUrl: 'https://helpdesk.gigatel.solutions:60205/api/',
  iciciApiUrl: 'https://helpdesk.gigatel.solutions:40905/api/',
  iciciRedirectPortalUrl: 'https://pgpay.icicibank.com/pg/api/v2/authRedirect?tranCtx=',


  //////////////////////////////////////Production////////////////////////////////////////////////  

  apiDirections: 'https://api.olamaps.io/routing/v1/directions',
};